<template>
    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange">
        <Ctest :navsub="navsub" :options="c_myoption" v-if="isload"></Ctest>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'test',
        mixins: [mixinmember],
        components: {
            Ctest: () => import('@/components/Ctest')
        },
        data() {
            return {
                curnavkv: 5
            };
        },
        computed: {
            c_options: function () {
                let _options = { 'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'noteng': 1, 'issch': 1, 'anycourse': true };
                switch (this.navsub) {
                    case 0:
                        _options.schstat = 1;
                        break;
                    case 1:
                        _options.schstat = 2;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                switch (this.navsub) {
                    case 0:
                        _myoption.schstat = 1;
                        break;
                    case 1:
                        _myoption.schstat = 2;
                        break;
                }
                return _myoption;
            }
        }
    }
</script>
